import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { useState } from 'react';
import { useEditorStateContext } from '../../context/notes/notes_editor_state_context';
import { Modal, Subheader, AppText, Row, Theme } from '../../index';
import { Button } from '../buttons/button';
export const SendNoteModal = ({ isOpen, closeModal }) => {
    const { sendNote } = useEditorStateContext();
    const [saveDisabled, setSaveDisabled] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const send = async () => {
        setSaveDisabled(true);
        setIsLoading(true);
        try {
            await sendNote();
        }
        finally {
            setSaveDisabled(false); // ensure proper state if modal re-opened
            setIsLoading(false);
            closeModal();
        }
    };
    return (_jsxs(Modal, { isOpen: isOpen, closeOnEscape: true, hideCloseButton: true, styleOverride: {
            content: {
                width: '36.25rem',
                padding: Theme.spacing.l,
            },
        }, children: [_jsx(Subheader, { style: { marginBottom: '1.5rem' }, children: "Are You Sure?" }), _jsx(AppText, { children: "Once sent, this version of the note will be used by other platforms. Some may continue to receive updates." }), _jsxs(Row, { justifyContent: "flex-end", width: "100%", marginTop: "2.25rem", style: { gap: '1.125rem' }, children: [_jsx(Button, { variant: "secondary", onClick: closeModal, "data-testid": "cancel-send-note-modal-button", children: "Cancel" }), _jsx(Button, { onClick: send, loading: isLoading, disabled: saveDisabled, "data-testid": "send-note-modal-button", children: "Send Note" })] })] }));
};
//# sourceMappingURL=send_note_modal.js.map